const initState = {
  loading: false,
  addLoading: false,
  imageLoading: false,
  chargesDeleteLoading: false,
  bannerRemoveLoading: false,
  additionalCharges: [],
  storeLoading: false,
  pickupLoading: false,
  deliveryLoading: false,
  currencyLoading: false,
  paymentConnectionLoading: false,
  addHolidayLoading: false,
  deleteHolidayLoading: false,
  removeLoader: false,
  addForwardFeesLoader: false,
  getForwardFeesLoader: false,
  deleteForwardFeeLoader: false,
  updateForwardFeesLoader: false,
  removePaymentLoader: false,
  tipLoader: false,
  forwardFee: [],
  storeTimings: []
};
const settingReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_LOADER":
      return {
        ...state,
        loading: action.payload
      };
    case "FETCH_ADDITIONAL_CHARGES_SUCCESS":
      return {
        ...state,
        additionalCharges: action.payload
      };
    case "ADD_LOADER":
      return {
        ...state,
        addLoading: action.payload
      };
    case "CHARGES_LOADER":
      return {
        ...state,
        chargesLoading: action.payload
      };
    case "CHARGES_DELETE_LOADER":
      return {
        ...state,
        chargesDeleteLoading: action.payload
      };
    case "CATALOG_LOADER":
      return {
        ...state,
        loading: action.payload
      };
    case "PICKUP_LOADER":
      return {
        ...state,
        pickupLoading: action.payload
      };
    case "STORE_TIMING_LOADER":
      return {
        ...state,
        storeLoading: action.payload
      };
    case "DELIVERY_LOADER":
      return {
        ...state,
        deliveryLoading: action.payload
      };
    case "REMOVE_BANNER_LOADER":
      return {
        ...state,
        bannerRemoveLoading: action.payload
      };
    case "IMAGE_LOADER":
      return {
        ...state,
        imageLoading: action.payload
      };
    case "GET_FORWARD_FEES_LOADER":
      return {
        ...state,
        getForwardFeesLoader: action.payload
      };
    case "ADD_FORWARD_FEES_LOADER":
      return {
        ...state,
        addForwardFeesLoader: action.payload
      };

    case "DELETE_FORWARD_FEES_LOADER":
      return {
        ...state,
        deleteForwardFeeLoader: action.payload
      };
    case "UPDATE_FORWARD_FEES_LOADER":
      return {
        ...state,
        updateForwardFeesLoader: action.payload
      };
    case "ADD_HOLIDAY_LOADER":
      return {
        ...state,
        addHolidayLoading: action.payload
      };
    case "DELETE_HOLIDAY_LOADER":
      return {
        ...state,
        deleteHolidayLoading: action.payload
      };
    case "REMOVE_LOADER":
      return {
        ...state,
        removeLoader: action.payload
      };
    case "TIP_LOADER":
      return {
        ...state,
        tipLoader: action.payload
      };
    case "PAYMENT_CONNECTION_LOADER":
      return {
        ...state,
        paymentConnectionLoading: action.payload
      };

    case "REMOVE_PAYMENT_LOADER":
      return {
        ...state,
        removePaymentLoader: action.payload
      };
    case "SET_CURRENCY_LOADER":
      return {
        ...state,
        currencyLoading: action.payload
      };
    case "GET_FORWARD_FEE":
      return {
        ...state,
        forwardFee: Array.isArray(action.payload) ? action.payload : []
      };

    case "FETCH_STORE_TIMINGS":
      return {
        ...state,
        storeTimings: action.payload
      };

    case "UPDATE_STORE_TIMING":
      return {
        ...state,
        storeTiming: action.payload
      };

    default:
      return {
        ...state
      };
  }
};
export default settingReducer;
